(() => {
    const bnrTemplate = $('#bnr-in-content');
    const bnrTemplate2 = $('#bnr-in-content-floated');
    const itemContent = $('.default__item--default-content');

    if (bnrTemplate.length) {
        let bnr = bnrTemplate.html();
        bnr = $(bnr);
        if (!itemContent.find('p').length / 2) {
            itemContent.append(bnr)
        } else {
            let pLen = Math.ceil((itemContent.find('p').length / 2));
            itemContent.find('p').eq(pLen).after(bnr);
        }
    }

    if (bnrTemplate2.length) {
        let bnr = bnrTemplate2.html();
        // let _pIndex = bnrTemplate2.data('pindex');
        // if (typeof _pIndex === 'undefined' || isNaN(_pIndex)) {
        //     _pIndex = 2;
        // }
        // let _pIndex = 2;
        bnr = $(bnr);
        if (itemContent.find('p').length >= 4) {
            itemContent.find('p').eq(0).after(bnr);
        }
    }


})();
